var Alert_module_default = {
	alert: "_alert_zx76t_10",
	content: "_content_zx76t_37",
	"text-content": "_text-content_zx76t_44",
	title: "_title_zx76t_48",
	icon: "_icon_zx76t_48",
	actions: "_actions_zx76t_64"
};
//#endregion
export { Alert_module_default as default };

//# sourceMappingURL=Alert.module.js.map